import type { Operation } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';

export const isMutation = ({ operation }: { operation: Operation }) => {
  const def = getMainDefinition(operation.query);
  return (
    def && def.kind === 'OperationDefinition' && def.operation === 'mutation'
  );
};
